import {gql} from 'graphql-request';
import {
    nullCollapsableArguments, nullCollapsableClientPubId, nullCollapsablePrivilegeLevel, nullCollapsableSaasPubId
} from 'src/services/shared/nullCollapsableUtilities';
import {saasUserFragment} from 'src/services/shared/Fragments';
import {
    transformConnectedSaasFlat,
    transformUser
} from 'src/services/shared/sharedTransforms';
import {doAuthenticatedQuery} from "src/services/shared/doQuery";
import {QueryContext} from "../../hooks/TanstackHooks";

const getSharedMailboxesWithLoginQuery = gql`
    query getSharedMailboxesWithLogin(
        $privilegeLevelBoolExp: privilege_level_comparison_exp,
        $saasIdentifierBoolExp: saas_bool_exp,
        $connectionIdBoolExp: client_saas_bool_exp,
        $clientBoolExp: client_bool_exp,
    ) {
        latest_saas_user(
            where: {
                client: $clientBoolExp,
                privilege_level: $privilegeLevelBoolExp,
                saas: $saasIdentifierBoolExp,
                connection: $connectionIdBoolExp,
                account_type: {_eq: "shared"},
                status: {_eq: "Enabled"}
            },
            order_by:[
                {privilege_level: asc},
                {last_login: asc}
            ]
        ) {
              ...User
        }
    }
    ${saasUserFragment}
`;

const getSharedMailboxesWithLoginCountQuery = gql`
    query getSharedMailboxesWithLoginCount(
      $privilegeLevelBoolExp: privilege_level_comparison_exp,
      $saasIdentifierBoolExp: saas_bool_exp,
      $connectionIdBoolExp: client_saas_bool_exp,
      $clientBoolExp: client_bool_exp,
    ) {
      latest_saas_user_aggregate(
        where: {
          client: $clientBoolExp,
          privilege_level: $privilegeLevelBoolExp,
          saas: $saasIdentifierBoolExp,
          connection: $connectionIdBoolExp,
          account_type: {_eq: "shared"},
          status: {_eq: "Enabled"}
        },
        order_by:[
          {privilege_level: asc},
          {last_login: asc}
        ]
      ) {
          aggregate {
              count
          }
      }
    }
`;

export const getSharedMailboxesWithLogin = async ({accessToken, queryContext, parameters}:{
    accessToken: any,
    queryContext: QueryContext,
    parameters: any}
) => {
    const {
        saasIdentifier,
        connectionId,
        privilegeLevel,
    } = parameters;


    const theQuery = async (client: any) => {
        const optionalArguments = nullCollapsableArguments({
            saasIdentifier,
            privilegeLevel
        })

        const variables = {
            privilegeLevelBoolExp:
                nullCollapsablePrivilegeLevel(privilegeLevel),
            "connectionIdBoolExp": nullCollapsableSaasPubId(connectionId),
            saasIdentifierBoolExp: optionalArguments.saasIdentifierBoolExp,
            ...nullCollapsableClientPubId(queryContext.client.id)
        }

        const result = client.request(
            getSharedMailboxesWithLoginQuery,
            variables,
        );
        return result;
    };

    let response;
    try {
        response = await doAuthenticatedQuery(
            theQuery, accessToken
        );
    }
    catch (error) {
        console.error('getSharedMailboxesWithLogin error', {error})
        throw (error)
    }

    const result = response.latest_saas_user.map((user: any) => {
        return {
            ...(transformUser(
                user,
            )),
            saas: transformConnectedSaasFlat(
                user.saas,
                user.connection
            ),
        };
    });
    return result;
};


export const getSharedMailboxesWithLoginCount = async ({accessToken, queryContext, parameters}:{
    accessToken: any,
    queryContext: QueryContext,
    parameters: any}
) => {
    const {
        saasIdentifier,
        connectionId,
        privilegeLevel,
    } = parameters;


    const theQuery = async (client: any) => {
        const optionalArguments = nullCollapsableArguments({
            saasIdentifier,
            privilegeLevel
        })

        const variables = {
            privilegeLevelBoolExp:
                nullCollapsablePrivilegeLevel(privilegeLevel),
            "connectionIdBoolExp": nullCollapsableSaasPubId(connectionId),
            saasIdentifierBoolExp: optionalArguments.saasIdentifierBoolExp,
            ...nullCollapsableClientPubId(queryContext.client.id),
        }

        const result = client.request(
            getSharedMailboxesWithLoginCountQuery,
            variables,
        );
        return result;
    };

    let response;
    try {
        response = await doAuthenticatedQuery(
            theQuery, accessToken
        );
    }
    catch (error) {
        console.error('getSharedMailboxesWithLoginCount error', {error})
        throw (error)
    }

    return response.latest_saas_user_aggregate.aggregate.count;
};
